/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, HostListener } from '@angular/core';
import { UserSessionService } from 'app/services/user-session.service';
import 'jszip';
import * as JSZip from 'jszip';
window['JSZip'] = JSZip;

// Had to modify a file (readable-stream-browser.js) in the jszip node_modules folder
// from "module.exports = require("stream");"
// to   "module.exports = require("readable-stream");"
// see https://github.com/DevExpress/devextreme-angular/issues/776

@Component({
  selector: 'knect-app',
  template: `
    <router-outlet></router-outlet>
  `
})
export class AppComponent implements OnInit {

  constructor(private _userSession: UserSessionService) { }

  ngOnInit(): void {     
  }

  // only use refresh data timer when idle
  // hostlistener event handlers + refreshDataTimer determine active vs idle
  // hostlistener here so events are captured site wide
  @HostListener('mousemove') onMouseMove(): void {
    this._userSession.resetRefreshTimer();
  }

  @HostListener('keypress') onKeyPress(): void {
    this._userSession.resetRefreshTimer();
  }

  @HostListener('click') onClick(): void {
    this._userSession.resetRefreshTimer();
  }
}
